import { render } from "./healthSlider.vue?vue&type=template&id=998bd69c&scoped=true"
import script from "./healthSlider.vue?vue&type=script&lang=js"
export * from "./healthSlider.vue?vue&type=script&lang=js"

import "./healthSlider.vue?vue&type=style&index=0&id=998bd69c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-998bd69c"]])

export default __exports__